import { render, staticRenderFns } from "./SkillDataCollection.vue?vue&type=template&id=d1313b94&scoped=true&"
import script from "./SkillDataCollection.vue?vue&type=script&lang=js&"
export * from "./SkillDataCollection.vue?vue&type=script&lang=js&"
import style0 from "./SkillDataCollection.vue?vue&type=style&index=0&id=d1313b94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1313b94",
  null
  
)

export default component.exports